import { render, staticRenderFns } from "./workOrderHeaderInfo.vue?vue&type=template&id=ddf1a226&scoped=true&"
import script from "./workOrderHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./workOrderHeaderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf1a226",
  null
  
)

export default component.exports